import { ValidatorFn, AbstractControl } from '@angular/forms';
import { VALIDATION_ERROR } from '@models-global/validation-errors';
import { formatDistanceStrict } from 'date-fns';

export function validatorCompareEndDate(
  fieldFrom = 'effectiveDate',
  fieldTo = 'endDate',
  allowEqual = false
): ValidatorFn {
  return (form: AbstractControl): { [key: string]: boolean } | null => {
    const endDateControl = form.get(fieldTo)!;
    const effectiveDateControl = form.get(fieldFrom)!;

    if (
      endDateControl.value &&
      effectiveDateControl.value &&
      (new Date(endDateControl.value).getTime() <
        new Date(effectiveDateControl.value).getTime() ||
        (!allowEqual &&
          new Date(endDateControl.value).getTime() ===
            new Date(effectiveDateControl.value).getTime()))
    ) {
      endDateControl.setErrors({ [VALIDATION_ERROR.DATE_LESS_THEN]: true });
      effectiveDateControl.setErrors({
        [VALIDATION_ERROR.DATE_LESS_THEN]: true
      });
      endDateControl.markAsTouched();
      effectiveDateControl.markAsTouched();

      return { [VALIDATION_ERROR.DATE_LESS_THEN]: true };
    }

    endDateControl.setErrors(null);
    effectiveDateControl.setErrors(null);
    return null;
  };
}

export function validatorCompareEndDateHalfYear(
  fieldFrom = 'effectiveDate',
  fieldTo = 'endDate'
): ValidatorFn {
  return (form: AbstractControl): { [key: string]: boolean } | null => {
    const endDateControl = form.get(fieldTo)!;
    const effectiveDateControl = form.get(fieldFrom)!;

    if (effectiveDateControl.value && endDateControl.value) {
      const monthsBtw = parseFloat(
        formatDistanceStrict(
          new Date(effectiveDateControl.value),
          new Date(endDateControl.value),
          {
            unit: 'month',
            roundingMethod: 'floor'
          }
        ).split(' ')[0]
      );

      if (monthsBtw < 6) {
        endDateControl.setErrors({ [VALIDATION_ERROR.DATE_LESS_THEN]: true });
        effectiveDateControl.setErrors({
          [VALIDATION_ERROR.DATE_LESS_THEN]: true
        });
        endDateControl.markAsTouched();
        effectiveDateControl.markAsTouched();

        return { [VALIDATION_ERROR.DATE_LESS_THEN]: true };
      }
    }
    endDateControl.setErrors(null);
    effectiveDateControl.setErrors(null);
    return null;
  };
}
